import React, { useContext, useEffect, useState } from 'react'
import '../../assets/styles/componentStyles/pageNotFound.css'
import { Button, Grid, Typography } from '@mui/material'
import chronoxLogo from '../../assets/images/global/Chronox Logo.png'
import { useNavigate } from 'react-router-dom'
import { primaryColor } from '../../utils/colors'
import { UserContext, UserContextPayload } from '../../context/userContext'
import { getVendorField } from '../../utils/whiteLabelling'


const PageNotFound = () => {

    const navigate = useNavigate()
    const [flagVisible, setFlagVisible] = useState(false);
    const { vendorData } = useContext(UserContext) as UserContextPayload

    useEffect(() => {
        setTimeout(() => {
            setFlagVisible(true)
        }, 700);
    }, [])

    return (
        <>
            {flagVisible &&
                <Grid container className='ww-pnf-main-container'>
                    <Grid item xs={11} sm={10} md={8} className='ww-pnf-main-item'>
                        <Grid container>
                            <Grid item xs={12} className='ww-pnf-logo-item'>
                                <img
                                    src={getVendorField(vendorData, "company primary logo", chronoxLogo)}
                                    alt={getVendorField(vendorData, "company name", "Chronox")}
                                    style={{ width: "200px", height: "auto", cursor: "pointer" }}
                                    onClick={() => { navigate('/dashboard') }}
                                />
                            </Grid>
                            <Grid item xs={12} className='ww-pnf-text-item'>
                                <Typography component={'span'} className='ww-pnf-text'>Page Not Found</Typography>
                            </Grid>
                            <Grid item xs={12} className='ww-pnf-subtext-item'>
                                <Grid container sx={{ justifyContent: "center" }}>
                                    <Grid item xl={5} lg={5} md={7} sm={9} xs={11}>
                                        <Typography component={'span'} className='ww-pnf-subtext-text'>
                                            The page you are looking for doesn't exist
                                            or has been moved
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item className='ww-pnf-home-page-btn'>
                                <Button
                                    variant='contained'
                                    fullWidth
                                    size='large'
                                    sx={{
                                        color: "white",
                                        textTransform: "none",
                                        background: primaryColor,
                                        borderRadius: "5px",
                                        fontWeight: "500",
                                        padding: "8px 25px !important",
                                        '&.MuiButton-root:hover': { bgcolor: primaryColor },
                                        boxShadow: "rgba(17, 12, 46, 0.15) 0px 48px 100px 0px",
                                        fontSize: "17px",
                                    }}
                                    onClick={() => { navigate('/') }}
                                >
                                    Back to homepage
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default PageNotFound